import { gql } from "@apollo/client";
const DELETE_RANKING_ENTRY = gql`
  mutation removeTournamentRankingsEntry($id: Int!) {
    removeTournamentRankingsEntry(id: $id) {
      id
    }
  }
`;
export default DELETE_RANKING_ENTRY;
